import { IcoPlusSmall16 } from '@onefootprint/icons';
import type { ProxyIngressRule } from '@onefootprint/request-types/dashboard';
import { Form, LinkButton } from '@onefootprint/ui';
import { FormProvider, useFieldArray, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { FormData, StepProps } from '@/pages/developers/vault-proxy/pages/list/vault-proxy.types';
import FormGrid from '../form-grid';
const defaultRule: ProxyIngressRule = {
  token: '' as ProxyIngressRule['token'],
  target: ''
};
const IngressVaulting = ({
  id,
  onSubmit,
  values
}: StepProps) => {
  const {
    t
  } = useTranslation('vault-proxy', {
    keyPrefix: 'create.form.ingressVaulting'
  });
  const form = useForm<FormData>({
    defaultValues: {
      ingressSettings: {
        contentType: values.ingressSettings.contentType || 'none',
        // Always default to having at least one rule
        rules: values.ingressSettings.rules.length ? values.ingressSettings.rules : [defaultRule]
      }
    }
  });
  const ingressContentType = form.watch('ingressSettings.contentType');
  const {
    fields,
    append,
    remove
  } = useFieldArray({
    control: form.control,
    name: 'ingressSettings.rules'
  });
  const handleAdd = () => {
    append(defaultRule);
  };
  const handleRemove = (index: number) => () => {
    remove(index);
  };
  return <FormProvider {...form}>
      <form id={id} onSubmit={form.handleSubmit(data => onSubmit(data as FormData))}>
        <p className="text-label-2 text-primary mb-4 fp-text">{t($ => $.title)}</p>
        <div className="mb-8">
          <Form.Select<FormData> size="compact" name="ingressSettings.contentType" label={t($_0 => $_0.contentType.label)} options={[{
          label: 'None',
          value: 'none'
        }, {
          label: 'JSON',
          value: 'json'
        }]} />
        </div>
        {ingressContentType !== 'none' && <>
            <p className="text-label-2 text-primary mb-4 fp-text">{t($_1 => $_1.vaultingRules.title)}</p>
            <FormGrid>
              {fields.map((field, index_0) => <div key={field.id}>
                  <div className="grid gap-4 mb-2">
                    <Form.Input<FormData> size="compact" name={`ingressSettings.rules.${index_0}.token`} label={t($_2 => $_2.vaultingRules.token.label)} placeholder={t($_3 => $_3.vaultingRules.token.placeholder)} rules={createValidationOptions(index_0, t($_4 => $_4.vaultingRules.token.errors.required))} />
                    <Form.Input<FormData> size="compact" name={`ingressSettings.rules.${index_0}.target`} label={t($_5 => $_5.vaultingRules.target.label)} placeholder={t($_6 => $_6.vaultingRules.target.placeholder)} rules={createValidationOptions(index_0, t($_7 => $_7.vaultingRules.target.errors.required))} />
                  </div>
                  {fields.length >= 2 && <LinkButton onClick={handleRemove(index_0)} destructive>
                      Remove
                    </LinkButton>}
                </div>)}
            </FormGrid>
            <LinkButton iconComponent={IcoPlusSmall16} iconPosition="left" onClick={handleAdd}>
              {t($_8 => $_8.addMore)}
            </LinkButton>
          </>}
      </form>
    </FormProvider>;
};
const createValidationOptions = (index: number, message: string) => {
  if (index === 0) {
    return {
      required: {
        value: true,
        message
      }
    };
  }
  return undefined;
};
export default IngressVaulting;